export default {
  getQueryVariable (variable: string) {
    const query = window.location.search.substring(1)

    // if (!AuthModule.isProduction && variable === "appid") {
    //    query = "appid=1c1688c1-37aa-4888-a6d1-deb884f5facd"
    // }

    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      if (pair[0].toLowerCase() === variable.toLowerCase()) { return decodeURIComponent(pair[1]) }
    }
    return null
  },
  getQueryVariableFromUrl (url: string, variable: string) {
    const anchor = document.createElement('a')
    anchor.href = url
    const query = anchor.search.substring(1)
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      if (pair[0].toLowerCase() === variable.toLowerCase()) { return decodeURIComponent(pair[1]) }
    }
    return null
  }
}
